import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { getIpGeoLocationData, setIpGeoLocationData } from 'utils/localStorage';
import { omitDeep } from 'utils/objects';

const IP_GEOLOCATION_QUERY = gql`
  query MyIpGeoLocation($previous: CachedIpGeoLocationData) {
    ipGeoLocationData(previous: $previous) {
      ip
      country
      subdivisions
      promotionZone
      rmgWebsite
    }
  }
`;

const withData = graphql(IP_GEOLOCATION_QUERY, {
  name: 'ipGeoLocationData',
  options: props => {
    const previous = getIpGeoLocationData();
    return {
      variables: {
        previous: previous.ip ? previous : null
      },
      fetchPolicy: 'cache-first'
    };
  },
  props: ({ ownProps, ipGeoLocationData }) => {
    const data = ipGeoLocationData.ipGeoLocationData;
    if (
      !ipGeoLocationData.loading &&
      !ipGeoLocationData.error &&
      data &&
      data.ip
    ) {
      setIpGeoLocationData(omitDeep(data, '__typename'));
    }
    return { ipGeoLocationData };
  }
});

const withIpGeoLocationData = params =>
  params && params.skip ? comp => comp : withData;

export default withIpGeoLocationData;
